import { SiteFloorUpdate } from '~/modules/sites';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';

export default function SitePlaneEditPage() {
  usePageTitle(t('menu.dashboard.settingsSites'));
  return <SiteFloorUpdate />;
}
